<script lang="ts" setup>

import { trackClassroomEvent } from '../../lib/classroom'

defineOptions({
  name: 'LessonRoomScreenNearpod',
})

const props = defineProps<{
  code: string
}>()

const src = computed<string>(() => `https://app.nearpod.com/presentation?pin=${props.code}`)

onMounted(() => trackClassroomEvent('Share_start', { name: 'nearpod' }))
onBeforeUnmount(() => trackClassroomEvent('Share_stop', { name: 'nearpod' }))
</script>

<template>
  <div class="lesson-room-screen-nearpod">
    <iframe
      class="lesson-room-screen-nearpod__frame"
      :src="src"
      width="100%"
      height="100%"
      frameborder="0"
      allowfullscreen
      allow="accelerometer *; autoplay *; camera *; clipboard-read *; clipboard-write *; encrypted-media *; fullscreen *; geolocation *; gyroscope *; microphone *; picture-in-picture *; screen-wake-lock *; web-share *"
    />
  </div>
</template>

<style scoped lang="scss" src="./LessonRoomScreenNearpod.scss" />
